import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import { CloseButton } from 'components/Buttons';

const StyledCloseButton = styled(CloseButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: theme.zIndex.modal
}));

export function RouteModalCloseButton({ color, ...rest }) {
  return <StyledCloseButton IconProps={{ sx: { fill: color } }} {...rest} />;
}

RouteModalCloseButton.propTypes = {
  color: PropTypes.string
};
